<form [formGroup]="form" class="one-column">
  <mat-form-field appearance="fill">

      <mat-label>Înălțimea (A)</mat-label>
      <input matInput type="text" autocomplete="off" pattern="^[0-9]+[,.]?[0-9]*$" (change)="formDecimalInputChange($event, 'height', 0.8)"
             formControlName="height" required>
      <span matSuffix>metri</span>
    <div
      *ngIf="form.controls.height.invalid && (form.controls.height.dirty || form.controls.height.touched)"
      class="alert">
      <div *ngIf="form.controls.height.errors?.['min']">Minimul este de 0.8 metri.</div>
      <div *ngIf="form.controls.height.errors?.['max']">
        Maximul este de 2.5 metri
      </div>
    </div>
    </mat-form-field>

  <mat-form-field appearance="fill">

    <mat-label>Lățimea (B)</mat-label>
    <input matInput type="text" autocomplete="off" pattern="^[0-9]+[,.]?[0-9]*$" (change)="formDecimalInputChange($event, 'width')"
           formControlName="width"
           required>
    <span matSuffix>metri</span>
  </mat-form-field>
  <mat-form-field appearance="fill">

    <mat-label>Distanța dintre șipci (C)</mat-label>
    <input matInput type="text" autocomplete="off" pattern="^[0-9]+[,.]?[0-9]*$" (change)="formDecimalInputChange($event, 'distanceBetweenSlats')"
           formControlName="distanceBetweenSlats"
           required>
    <span matSuffix>metri</span>
  </mat-form-field>
</form>

